'use client';

import { useAppDispatch, useAppSelector } from '@/app/lib/store/hooks';
import { usePathname, useRouter } from 'next/navigation';
import { closeDrawer } from '@/app/lib/store/drawer-slice';
import { clearUser } from '@/app/lib/store/user-slice';
import { APP_URLS } from '@/app/lib/constants/app-urls';
import SidebarNavigation from './sidebar-navigation';
import { clearSearchParams } from '@/app/lib/store/search-params-slice';
import { ENDPOINTS } from '@/app/lib/constants/endpoints';
import { useEffect, useState } from 'react';
import { getFeatureFlagCached } from '@/app/lib/redis/cacheService';
import { configEndpoint } from '@/app/lib/utils/api-utils';

const SidebarNavigationContainer = () => {
  const branches = useAppSelector(state => state.navigation.branches);
  const pathname = usePathname();
  const router = useRouter();
  const dispatch = useAppDispatch();
  const user = useAppSelector(state => state.user.data);

  const handleBeforeNavigation = () => {
    dispatch(clearSearchParams());
    setTimeout(() => dispatch(closeDrawer()), 500);
  };

  const handleLogin = () => {
    router.push('/auth');
    setTimeout(() => dispatch(closeDrawer()), 500);
  };

  const handleSignUp = () => {
    router.push(APP_URLS.signUpChoosePlanUrl);
    setTimeout(() => dispatch(closeDrawer()), 500);
  };

  const handleLogout = async () => {
    const endpoint = configEndpoint(ENDPOINTS.logout);

    await fetch(endpoint, { method: 'POST' });

    dispatch(clearUser());

    const protectedRoutes = ['premium', 'profile'];
    const onProtectedRoute = pathname
      .split('/')
      .some(segment => protectedRoutes.includes(segment));

    if (onProtectedRoute) router.push('/');
    setTimeout(() => dispatch(closeDrawer()), 500);
  };

  const [isAuthEnabled, setIsAuthEnabled] = useState(false);

  useEffect(() => {
    const getAuthFeatureFlag = async () => {
      const demoMode = await getFeatureFlagCached('demo-mode');
      setIsAuthEnabled(!demoMode.enabled);
    };
    getAuthFeatureFlag();
  }, []);

  return (
    <SidebarNavigation
      branches={branches}
      pathname={pathname}
      user={user}
      onClick={handleBeforeNavigation}
      onLogin={handleLogin}
      onSignUp={handleSignUp}
      onLogout={handleLogout}
      isAuthEnabled={isAuthEnabled}
    />
  );
};
export default SidebarNavigationContainer;
